import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = BACKEND_URL.replace(/^http/, "ws") + "/api/ws";

// Auth is httpOnly-cookie based: the backend sets the `access_token`
// cookie on /auth/login and /auth/register, and clears it on /auth/logout.
// Because the frontend and backend share the same origin (via the k8s
// ingress), the browser automatically attaches the cookie to every axios
// request as long as `withCredentials` is enabled. No tokens ever touch
// localStorage — this closes off XSS-based token exfiltration.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
};

export default api;
